import gql from 'graphql-tag';

export const fetchClickAdvertisingSaveDocument = gql`
  mutation clickAdvertisingSave($input: AdvertisingAttributionInput!) {
    clickAdvertisingSave(input: $input)
  }
`;
